import { render, staticRenderFns } from "./APInvoice.vue?vue&type=template&id=0b8aa0da&scoped=true&"
import script from "./APInvoice.vue?vue&type=script&lang=js&"
export * from "./APInvoice.vue?vue&type=script&lang=js&"
import style0 from "./APInvoice.vue?vue&type=style&index=0&id=0b8aa0da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8aa0da",
  null
  
)

export default component.exports